module.exports = __webpack_public_path__ + "static/img/20200518-01.2ee0c3d.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/20200518-01.png
// module id = dPlr
// module chunks = 1